import React from 'react';
import KardexDetail from 'components/Tvendo/Inventory/Operations/Kardex/Kardex';

export default function () {
  return <KardexDetail />;
}
